class DalialiShippingEstimate extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-shipping-variants]')?.textContent || '[]');
    this.productDetails = this.closest('.product-details');
    this.onVariantUpdate = (event) => {
      if (!this.productDetails?.contains(event.target)) return;
      this.variantId = String(event.detail?.resource?.id || '');
      this.renderEstimate();
    };
    this.onQuantityChange = () => requestAnimationFrame(() => this.renderEstimate());

    this.productDetails?.addEventListener('variant:update', this.onVariantUpdate);
    this.productDetails?.addEventListener('input', this.onQuantityChange);
    this.productDetails?.addEventListener('change', this.onQuantityChange);
    this.productDetails?.addEventListener('click', this.onQuantityChange);
    this.renderEstimate();
  }

  disconnectedCallback() {
    this.productDetails?.removeEventListener('variant:update', this.onVariantUpdate);
    this.productDetails?.removeEventListener('input', this.onQuantityChange);
    this.productDetails?.removeEventListener('change', this.onQuantityChange);
    this.productDetails?.removeEventListener('click', this.onQuantityChange);
  }

  shippingCents(weight) {
    if (weight <= 500) return 600;
    if (weight <= 1000) return 700;
    if (weight <= 2000) return 900;
    if (weight <= 5000) return 1200;
    if (weight <= 10000) return 1500;
    if (weight <= 15000) return 1700;
    if (weight <= 20000) return 2000;
    if (weight <= 25000) return 3000;
    if (weight <= 30000) return 3300;
    return 11000;
  }

  money(cents) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  renderEstimate() {
    const formVariant = this.productDetails?.querySelector('input[name="id"]')?.value;
    const variantId = this.variantId || formVariant || this.dataset.variantId;
    const variant = this.variants.find((item) => String(item.id) === String(variantId)) || this.variants[0];
    if (!variant) return;

    const quantity = Math.max(1, Number(this.productDetails?.querySelector('input[name="quantity"]')?.value) || 1);
    const totalWeight = Math.max(0, Number(variant.weight) || 0) * quantity;
    const totalPrice = Math.max(0, Number(variant.price) || 0) * quantity;
    const remaining = Math.max(0, 5000 - totalPrice);
    const progress = Math.min(100, Math.round((totalPrice / 5000) * 100));

    const standardPrice = this.querySelector('[data-standard-price]');
    const relayMessage = this.querySelector('[data-relay-message]');
    const progressBar = this.querySelector('[data-relay-progress]');
    if (standardPrice) standardPrice.textContent = this.money(this.shippingCents(totalWeight));
    if (progressBar) progressBar.style.width = `${progress}%`;
    if (relayMessage) {
      relayMessage.textContent = remaining === 0
        ? 'Mondial Relay est gratuit pour cette sélection'
        : `Plus que ${this.money(remaining)} pour Mondial Relay gratuit`;
    }
  }
}

if (!customElements.get('daliali-shipping-estimate')) {
  customElements.define('daliali-shipping-estimate', DalialiShippingEstimate);
}
